import React, { useState, useEffect } from "react";
import envConstants from "../Constants";
import BrandSlider from "../Components/Sub-Components/BrandSlider";
import ProductSlider from "../Components/Sub-Components/ProductSlider";
import CategoryCard from "../Components/CategoryCard";
import PostGrid from "../Components/Sub-Components/PostsGrid";
import TestimonialSlider from "../Components/Sub-Components/TestimonialSlider";
import HomeSlider from "../Components/Sub-Components/HomeSlider";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import axios from "../Axiosapi";
import { useNavigate } from "react-router-dom";

const testimonials = [
  {
    id: 1,
    name: "John Doe",
    message:
      "Lorem ipsum dolor sit amet, consectetur adipis cing elit. Donec euismod, nisl eget consectetur adipiscing elit.",
    rating: 4,
  },
  {
    id: 2,
    name: "Jane Smith",
    message:
      "Lorem ipsum dolor sit amet, consectetur adipis cing elit. Donec euismod, nisl eget consectetur adipiscing elit.",
    rating: 5,
  },
  {
    id: 3,
    name: "Michael Johnson",
    message:
      "Lorem ipsum dolor sit amet, consectetur adipis cing elit. Donec euismod, nisl eget consectetur adipiscing elit.",
    rating: 3,
  },
];

const Home = () => {
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [latestProducts, setLatestProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const offerBanner = "/assets/images/banner-image.webp";
  const home404 = "/assets/images/home-404.webp";
  const navigate = useNavigate();

  const content = [
    {
      heading: "Auto Part Station – Trusted Auto Parts in Australia",
      text: "We at Auto Part Station we recognize how vital the reliability of auto parts is to maintaining your vehicle's performance. No matter if you're a skilled mechanic, a fan of cars or simply in need of a new component, we have an extensive range of high-quality items to meet your requirements. Based in Australia We're pleased to offer all over the country service that is a blend of ease of use, affordability, and professional assistance.",
    },
    {
      heading: "<h2>A Wide Range of Auto Parts to Suit Every Vehicle</h2>",
      text: (
        <p>
          We carry thousands of spare parts for a range of brands and models,
          such as SUVs, passenger cars, 4WDs, and commercial light vehicles. Our
          inventory is continuously updated to reflect the most recent parts and
          systems ranging from brake pads filters, brake pads, and parts for
          engines as well as electrical and suspension accessories. Trusted
          suppliers make all of the products we sell to ensure longevity and
          quality that allow you to enjoy your drive with confidence.
        </p>
      ),
    },
    {
      heading: "<h3>Australian Owned and Operated</h3>",
      text: (
        <p>
          Auto Part Station is 100 per cent Australian, operating and owned by
          the Australian government. We're dedicated to delivering top-quality
          service and products to workshops and drivers across the nation. Our
          knowledge of the local area and our industry experience gives us an
          edge in knowing the specific requirements of Australian motorists. No
          matter if you're located in the city or the outback, our goal is to
          provide quick, reliable service no matter where you are.
        </p>
      ),
    },
    {
      heading: "<h3>Easy Online Shopping and Fast Delivery</h3>",
      text: (
        <p>
          We make purchasing auto parts online easy and hassle-free. Our
          user-friendly website was created to help you locate the right part
          quickly. You can search by car make, part number or a specific
          category, then take advantage of safe online shopping. After your
          order has been processed the team will get to work to ensure quick
          dispatch and delivery straight to your doorstep. With reliable courier
          partners and a variety of warehouses across Australia We minimize
          delays and ensure that you are moving.
        </p>
      ),
    },
    {
      heading: "<h3>Expert Advice and Customer Support</h3>",
      text: (
        <p>
          We're not just selling parts; we're here to assist you in making the
          right decision. Our team of experts is willing to help you and answer
          any questions regarding compatibility installations, specifications,
          or installation. If you're looking to restore a classic vehicle or
          maintain your regular commute, You can rely on our knowledge each step
          of the way.
        </p>
      ),
    },
    {
      heading: "<h3>Quality You Can Trust, Prices You'll Love</h3>",
      text: (
        <p>
          We believe that top-quality automobile parts shouldn't have to come
          with a expensive prices. This is why we strive to ensure our prices
          remain affordable, while not sacrificing the quality. Long-standing
          connections with our suppliers enable us to provide great discounts
          across a variety of components. Additionally, we regularly offer
          specials and promotions to make it easier to save money.
        </p>
      ),
    },
    {
      heading: "<h3>Serving Mechanics, Dealerships, and Everyday Drivers</h3>",
      text: (
        <p>
          Auto Part Station proudly supplies workshop owners, individuals as
          well as businesses throughout Australia. No matter if you're
          purchasing an item for the first time or in bulk, we handle each order
          with the same respect and devotion. Our well-organized procedures and
          meticulous care for the most minor details have made us a dependable
          supplier to trade professionals and DIY mechanics as well.
        </p>
      ),
    },
    {
      heading: "<h4>Stay Informed and Keep Your Vehicle at Its Best</h4>",
      text: (
        <p>
          Alongside providing top-quality components, we also offer knowledge
          and tricks via our newsletter and blog. Stay up to date on the latest
          trends in automotive as well as maintenance tips and new products that
          are launched. Knowledge is power, and we're here to provide Australian
          motorists with the knowledge they need to maintain their vehicles in
          the best way possible.
        </p>
      ),
    },
    {
      heading: "<h4>Join Thousands of Satisfied Customers</h4>",
      text: (
        <p>
          With a steady stream of returning customers and glowing feedback, Auto
          Part Station is rapidly becoming the go-to brand in the auto parts
          industry of Australia. We are honored to play our part in making sure
          that Australian vehicles reliable, safe and ready for the road.
        </p>
      ),
    },
    {
      heading: "<h5>Start Shopping Today</h5>",
      text: (
        <p>
          Explore our vast selection of auto parts and experience what it's like
          to experience the Auto Part Station difference. No matter if you're
          replacing just one component or upgrading your complete system, Auto
          Part Station has it covered. Buy with confidence, and we'll assist you
          to get back on the road quicker, safer, more efficiently, and safer.
        </p>
      ),
    },
    {
      heading: "<h5>Popular Searches</h5>",
      text: (
        <p>
          <Link
            className="text-decoration-none text-black"
            to="/shop?category=steering-wheel-covers&page=1"
          >
            Socket & Ratchet Sets
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=sunshades&page=1"
          >
            Sunshades
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=steering-wheel-covers&page=1"
          >
            Steering Wheel Covers
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=Wheel-Covers&page=1"
          >
            Wheel Covers
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=Accessories&page=1"
          >
            Automotive Accessories
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=Wash-Detailing-Products&page=1"
          >
            Wash & Detailing Products
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=Air-Fresheners&page=1"
          >
            Air Fresheners
          </Link>{" "}
          |
          <Link
            className="text-decoration-none text-black ps-2"
            to="https://autopartstation.com.au/shop?category=tie-down-occy-straps-ropes-and-nets-&page=1"
          >
            Tie Down
          </Link>
        </p>
      ),
    },
  ];

  const [showAllContent, setShowAllContent] = useState(false);

  const toggleReadMore = () => {
    setShowAllContent(!showAllContent);
  };

  useEffect(() => {
    const FetchHomeData = async () => {
      try {
        const response = await axios.get(
          `${envConstants.API_BASE_URL}/home-page`
        );
        setCategories(response.data.data.category);
        setLatestProducts(response.data.data.product);
        setFeaturedProducts(response.data.data.virtual_product);
        setBrands(response.data.data.brand);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    FetchHomeData();
  }, []);

  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center p-5">
  //       <div className="spinner-border spinner-border-sm" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // } else if (error && error.message && error.message.includes("429")) {
  //   navigate("/too-many-requests");
  //   return null;
  // } else if (error) {
  //   return (
  //     <div className="d-flex justify-content-center flex-column align-items-center">
  //       <img
  //         src={home404}
  //         style={{ width: "40%", margin: "20px 0px" }}
  //         alt="Error Image"
  //       />
  //       <div style={{ marginTop: "10px", color: "red", textAlign: "center" }}>
  //         {error.message || "An unexpected error occurred."}
  //       </div>
  //     </div>
  //   );
  // }

  const canonicalUrl = "https://autopartstation.com.au/";
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Auto Part Station Pty Ltd",
    url: "https://autopartstation.com.au",
    logo: "https://autopartstation.com.au/auto-part.webp",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+61 490 533 318",
      contactType: "Customer Service",
      areaServed: "AU",
      availableLanguage: "English",
    },
    sameAs: [],
  };

  return (
    <div className="container p-0 p-sm-2">
      <Helmet>
        <title>Auto Parts and Accessories | Quality Tools & More</title>
        <meta
          name="description"
          content={
            "Shop premium auto parts and accessories. Enjoy 10% off on your first order! Fast shipping and easy returns."
          }
        />
        <meta
          name="author"
          content={
            envConstants.STORE_META_AUTHOR
              ? envConstants.STORE_META_AUTHOR
              : "Auto Part Station Store"
          }
        />
        <meta
          name="keywords"
          content={
            envConstants.STORE_META_KEYWORDS
              ? envConstants.STORE_META_KEYWORDS
              : "online store, purchase online"
          }
        />
        <link rel="canonical" href={canonicalUrl} />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <div className="home-slider justify-content-between">
        <div className="main-home-slide">
          <HomeSlider />
        </div>
        <div className="main-home-cards">
          <div
            className="main-home-banner banner-1"
            style={{
              priority: "high",
              loading: "eager",
            }}
          >
            <h2>
              <span>Automotive Covers</span>
            </h2>
            <a href="/shop?category=car-4wd-suv-van-boat-and-other-covers-&page=1">
              Shop Now
            </a>
          </div>
          <div className="main-home-banner banner-2">
            {/* <p>Start From $9.99</p> */}
            <h2>
              <span>Towing Trailers</span> Caravan Accessories
            </h2>
            <a href="/shop?category=towing-trailer-and-caravan-accessories-roof-racks-4wd-ramps-chocks-and-emergency-&page=1">
              Shop Now
            </a>
          </div>
        </div>
      </div>
      <div className="website-services d-flex justify-content-evenly flex-wrap">
        <div className="services">
          <div className="truck-icon"></div>
          <h3>Easy Free Delivery</h3>
          <p>On orders over $100</p>
        </div>

        <div className="services">
          <div className="safty-icon"></div>
          <h3>Premium Warranty</h3>
          <p>Up to 2 years</p>
        </div>

        <div className="services border-end-0">
          <div className="return-icon"></div>
          <h3>Easy Free Return</h3>
          <p>365 days return</p>
        </div>
      </div>

      <div className="category-section">
        <h2 className="heading-2">Shop by Categories</h2>
        <p className="theme-text">
          Check out all the feature categories for simple product discovery.
        </p>

        <CategoryCard categories={categories} loading={loading} />
      </div>
      <div className="porduct-section">
        <h2 className="heading-2">Featured Products</h2>
        <p className="theme-text">
          Check out our collection of the top Featured Products that encourage
          conversion.
        </p>
        <ProductSlider
          products={featuredProducts}
          categories={categories}
          badge="Featured"
          loading={loading}
        />
      </div>
      {/*  <div className="gift-banner d-flex justify-content-start align-items-center px-5" style={{ backgroundImage: `url(${giftBanner})` }}>
                <div className="gift-banner-box">TOOL</div>
                <div className="gift-banner-box-details">
                    <div className="text-light">$20 Gift Bonus</div>
                    <div className="text-warning">Special offer for today only</div>
                </div>
            </div>*/}
      <div className="porduct-section">
        <h2 className="heading-2">New Products</h2>
        <p className="theme-text">
          Check out our collection of the top New Products that encourage
          conversion.
        </p>
        <ProductSlider
          products={latestProducts}
          categories={categories}
          badge="New"
          loading={loading}
        />
      </div>
      <div className="card-banner">
        <div className="d-flex flex-wrap justify-content-between">
          <div className="card-banner-box card-banner-box-1">
            {/* <h5>START FROM $129</h5> */}
            <h3>
              <span>Batteries</span>
            </h3>
            <Link
              to="shop?category=Battery-Electrical-Products&page=1"
              className="shop-btn"
            >
              Shop Now
            </Link>
          </div>
          <div className="card-banner-box card-banner-box-2">
            {/*  <h5>BIG SAVING ON</h5> */}
            <h3>
              <span>Headlights</span> and Torches
            </h3>
            <Link to="/shop?category=Lighting&page=1" className="shop-btn">
              Shop Now
            </Link>
          </div>
        </div>
      </div>
      {/*<div className="porduct-section">
                <h2 className="heading-2">Bestseller Products</h2>
                <p className="theme-text">Check out our collection of the top Bestseller Products that encourage conversion.</p>
                <ProductSlider products={popularProducts} categories={categories} badge="Popular"/>
            </div> */}
      <div className="porduct-section d-none">
        <h2 className="heading-2">See What Our Customers Says</h2>
        <p className="theme-text">
          Check our latest reviews from customers and say your feedback.
        </p>
        <TestimonialSlider testimonials={testimonials} />
      </div>
      <div
        className="offer-banner p-md-3 p-3 mb-5 d-flex justify-content-end align-items-center"
        style={{ backgroundImage: `url(${offerBanner})` }}
      >
        <div className="offer-banner-box">
          <h5 className="text-warning">&nbsp;Limited Time Offer</h5>
          <h3 className="pb-md-3 pb-2">
            <span>CAR ACCESSORIES</span>
            <br />
            Wheel & Locks
          </h3>
          <a
            href="/shop?child_category=Wheel--Lock-Nuts&page=1"
            className="shop-btn btn btn-light"
          >
            Shop Now
          </a>
        </div>
      </div>
      <BrandSlider brands={brands} loading={loading} />
      <div className="my-5 home-content">
        {/* Show only the first heading and paragraph initially */}
        <h1>{content[0].heading}</h1>
        <p>
          {showAllContent ? (
            content[0].text
          ) : (
            <>
              {/* Limit the text if it's a string */}
              {typeof content[0].text === "string"
                ? content[0].text.slice(0, 700) + "..."
                : content[0].text}
            </>
          )}
        </p>

        {/* Show the rest of the content after "Read more" is clicked */}
        {showAllContent &&
          content.slice(1).map((item, index) => (
            <div key={index}>
              {/* Render heading as raw HTML */}
              <div dangerouslySetInnerHTML={{ __html: item.heading }} />
              <div>{item.text}</div>
            </div>
          ))}
        <div className="d-flex justify-content-end">
          <button onClick={toggleReadMore} className="read-more">
            {showAllContent ? "Read less" : "Read more"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
